import React from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18next';
import { Typo } from 'uikit/content';

const EnrollmentStatusText = ({ item, percentageTypoVariant = 's01' }) => {
  const { status, score = null, progress = null } = item;

  if (['passed', 'failed'].includes(status) && score !== null) {
    return (
      <Typo noWrap variant={percentageTypoVariant}>
        {i18n.t(`${status}-prefix`)}
        <Typo element="span" variant={percentageTypoVariant} weight="medium">
          {i18n.t('count-percent', { count: score })}
        </Typo>
      </Typo>
    );
  }

  if (status !== 'in-progress' || progress === null) {
    return (
      <Typo noWrap variant={percentageTypoVariant}>
        {i18n.t(status)}
      </Typo>
    );
  }

  return (
    <Typo noWrap variant={percentageTypoVariant}>
      {i18n.t('in-progress-prefix')}
      <Typo element="span" variant={percentageTypoVariant} weight="medium">
        {i18n.t('count-percent', { count: progress })}
      </Typo>
    </Typo>
  );
};

EnrollmentStatusText.propTypes = {
  item: PropTypes.shape({
    status: PropTypes.string.isRequired,
    score: PropTypes.number,
    progress: PropTypes.number,
  }).isRequired,
  percentageTypoVariant: PropTypes.string,
};

export default EnrollmentStatusText;
